var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgGrayCalendarR = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.5,
  d: "M2.5 8.85417H17.5M14.1667 2.1875V5.52083M5.83333 2.1875V5.52083M14.1667 3.85417H5.83333C4.94928 3.85417 4.10143 4.20536 3.47631 4.83048C2.85119 5.4556 2.5 6.30345 2.5 7.1875V14.4792C2.5 15.3632 2.85119 16.2111 3.47631 16.8362C4.10143 17.4613 4.94928 17.8125 5.83333 17.8125H14.1667C15.0507 17.8125 15.8986 17.4613 16.5237 16.8362C17.1488 16.2111 17.5 15.3632 17.5 14.4792V7.1875C17.5 6.30345 17.1488 5.4556 16.5237 4.83048C15.8986 4.20536 15.0507 3.85417 14.1667 3.85417Z",
  stroke: "#171717",
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgGrayCalendarR);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/gray-calendar-r.e5809adad6170c74dedd9ede0f5eeba7.svg";